// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import PEDialogSegmentArray from './components/PEDialogSegmentArray';

const PEDialogInteraction = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;  

  return (
    <div>
      <NumberedHeading number="1" title="Dialog Segment" instructions="Add 1 segment per" />      
      <Controller
        control={control}
        name="content.dialog_segments"
        render={({ field }) => <PEDialogSegmentArray inputDir={inputDir} {...{ control, errors }} />}
      />
    </div>
  )
}

export default PEDialogInteraction;